import { reactive } from "vue";
export const useLog = reactive({
  logFlag: false,
  setLogFlag(flag) {
    this.logFlag = flag;
  },
  getLogFlag() {
    return this.logFlag;
  }
});
